<template>
	<div v-if="groupData" class="card border">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h5 class="header-case">Group Settings</h5>
			<button class="btn btn-danger" @click="deleteGroup" :disabled="isProcessing">
				Delete Group
			</button>
		</div>
		<div class="card-body">
			<div class="row">
				<div class="col-6">
					<h6 class="header-case card-header pl-4">Edit Group Name</h6>
					<div class="form-group ml-4">
						<label for="groupName">Group Name</label>
						<input
							type="text"
							id="groupName"
							class="form-control"
							v-model="groupName"
							:disabled="isProcessing"
						/>
						<button
							class="btn btn-primary mt-3"
							@click="updateGroup"
							:disabled="isProcessing"
						>
							Save Changes
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else class="loader d-block text-center">
		<p><i class="fas fa-circle-notch fa-spin"></i> Loading...</p>
	</div>
</template>

<script>
export default {
	props: {
		groupData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			groupName: this.groupData.name || '',
			isProcessing: false,
		};
	},
	methods: {
		async updateGroup() {
			this.isProcessing = true;
			try {
				await axios.put(`/api/groups/${this.groupData.groupInfo.id}/settings`, {
					name: this.groupName,
				});
				swal('Updated!', 'Group name has been successfully updated.', 'success');
				this.$emit('update-triggered', true);
			} catch (error) {
				console.error('There was an error updating the group name', error);
				swal('Failed!', 'Failed to update group name.', 'error');
			} finally {
				this.isProcessing = false;
			}
		},
		async deleteGroup() {
			this.isProcessing = true;
			try {
				await axios.delete(`/api/groups/${this.groupData.groupInfo.id}`);
				swal('Deleted!', 'Group has been successfully deleted.', 'success');
				this.$emit('update-delete');
			} catch (error) {
				console.error('There was an error deleting the group', error);
				swal('Failed!', 'Failed to delete the group.', 'error');
			} finally {
				this.isProcessing = false;
			}
		},
	},
};
</script>
<style scoped>
.loader p {
	margin: 0;
	font-size: 1.2em;
}

.card .card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 10px 20px 28px;
}
</style>
